import React from 'react';
import { TextField, DateField, useTranslate } from 'react-admin';
import { SingleRecordList } from '../../components/common/SingleRecordList';

export const AboutList: React.FC = () => {
  const translate = useTranslate();

  const fields = [
    <TextField key="title" source="title" label={translate('about.fields.title')} />,
    <TextField key="phone" source="phone" label={translate('about.fields.phone')} />,
    <TextField key="email" source="email" label={translate('about.fields.email')} />,
    <DateField key="updatedAt" source="updatedAt" label={translate('ra.field.updatedAt')} showTime />,
  ];

  return (
    <SingleRecordList
      resource="about"
      title={translate('about.title')}
      emptyMessage={translate('about.messages.notFound')}
      createButtonLabel={translate('about.actions.create')}
      editButtonLabel={translate('about.actions.edit')}
      fields={fields}
    />
  );
};
